import React, { useEffect } from 'react';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';

import { VehicleCard } from 'Storybook/components/local/VehicleCard';

import SoldTag from '../../../../../client/assets_seller/documentCapture/sold-tag.png';
import { ConfettiOverlay } from '../../../../components/confetti/ConfettiOverlay';
import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';
import PageLoader from '../../../../components/transitions/PageLoader/PageLoader';
import { useDealerRatingsExperiment } from '../../experiments/useDealerRatingsExperiment/useDealerRatingsExperiment';
import { useValuationLoaderLocalStorage } from '../../fastlane/valuations/components/ValuationLoader/useValuationLoaderLocalStorage';
import { useGetOfferBids } from '../useGetOfferBids';

import { Footer } from './Footer/Footer';
import { OfferSummaryContextProvider, useOfferSummary } from './hooks/useOfferSummary';
import { InfoList } from './InfoList/InfoList';
import { TrustPilotReviews } from './TrustPilotReviews/TrustPilotReviews';

import styles from './OfferSummary.styles.scss';

export const OfferSummary = () => {
  const {
    isEnquiryLoaded,
    offer,
    seller: { isBereavement },
    vehicle: { image, vrmPretty, ...vehicleDetails },
  } = useOfferSummary();
  const { removeEnquiry: removeValuationLoaderEnquiry } = useValuationLoaderLocalStorage();

  // This should be replaced by adding closingBidValue to useMotorwayOffer hook response
  const { loading: offerBidsLoading, offer: offerBids } = useGetOfferBids({
    dpEnquiryId: offer?.offerId,
    vrm: vehicleDetails?.vrm,
  }) ?? {};

  const { isEligibleForExperiment } = useDealerRatingsExperiment({
    dpEnquiryId: offer?.offerId,
    offer: offerBids,
  });

  const { maxWidth } = useBreakpoint();

  const isMobile = maxWidth.breakpointMobile;

  const badge = <img src={SoldTag} width="80" />;
  useEffect(() => {
    if (isEnquiryLoaded) {
      DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.CONFIRM_SALE_PAGE_LOAD();
    }
  }, [isEnquiryLoaded]);

  useEffect(() => {
    removeValuationLoaderEnquiry();
  }, [removeValuationLoaderEnquiry]);

  if (!isEnquiryLoaded || offerBidsLoading) {
    // I really don't like this but with the current route wrappers it was either adding the loader into the page
    // despite being inside the wrapping layout components OR add the enquiry call to every document capture route.
    return (
      <div className={styles.loaderWrapper}>
        <PageLoader />
      </div>
    );
  }

  return (
    <>
      {!isBereavement && <ConfettiOverlay />}
      <div className={styles.infoContainer} data-dealer-ratings-experiment={isEligibleForExperiment}>
        <div className={styles.saleInfoContainer}>
          <InfoList closingBidValue={offerBids?.closingBid?.value!} />
          <TrustPilotReviews />
        </div>
        <div className={styles.vehicleInfoContainer}>
          <VehicleCard
            badge={badge}
            image={image as string}
            showVehicleInfo={!isMobile}
            vehicleDetails={vehicleDetails}
            vrm={vrmPretty}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export const OfferSummaryWithContext = () => (
  <OfferSummaryContextProvider>
    <OfferSummary />
  </OfferSummaryContextProvider>
);
